const faqIds = {
  IS_IT_FREE: 'IS_IT_FREE',
  HAVE_I_A_COMMITMENT: 'HAVE_I_A_COMMITMENT',
  CAN_I_MODIFY_THE_APPOINTMENT: 'CAN_I_MODIFY_THE_APPOINTMENT',
  WHEN_I_GET_PAID: 'WHEN_I_GET_PAID'
}

export const faqQuestions = {
  [faqIds.IS_IT_FREE]: {
    question: `¿El servicio es gratuito?`,
    answer: `Sí, como vendedor no tendrás que pagar nada. El profesional se ocupará de todo el papeleo y gestiones.`,
    tracking: 'el servicio es gratuito'
  },
  [faqIds.HAVE_I_A_COMMITMENT]: {
    question: `¿Tengo algún compromiso?`,
    answer: `La decisión de vender o no es tuya, no existe ningún compromiso hasta que no firmes el contrato de compra-venta.`,
    tracking: 'tengo algun compromiso'
  },
  [faqIds.CAN_I_MODIFY_THE_APPOINTMENT]: {
    question: `¿Puedo modificar la cita?`,
    answer: `Sí, una vez agendada la cita te facilitaremos el teléfono del profesional por si tienes que realizar algún cambio de hora o día.`,
    tracking: 'puedo modificar la cita'
  },
  [faqIds.WHEN_I_GET_PAID]: {
    question: `¿Cuando recibiré el pago?`,
    answer: `Una vez entregado el vehículo (tú eliges cuando hacerlo) recibirás el dinero en un máximo de 24-48h.`,
    tracking: 'cuando recibire el pago'
  }
}

export const faqTracking = [
  faqQuestions[faqIds.IS_IT_FREE].tracking,
  faqQuestions[faqIds.HAVE_I_A_COMMITMENT].tracking,
  faqQuestions[faqIds.CAN_I_MODIFY_THE_APPOINTMENT].tracking,
  faqQuestions[faqIds.WHEN_I_GET_PAID].tracking
]
